<template>
    <div
        :class="{ 'uk-flex': horizontal }"
    >
        <div
            v-if="editable"
            :class="{ 'uk-margin-small-right': horizontal, 'uk-flex-item-1': horizontal, 'uk-width-1-1': !horizontal }"
        >
            <form-sourced-autosuggest
                entity="project"
                :id="id"
                :name="name"
                :id-field="idField"
                :label-field="labelField"
                :error="error"
                :required="false"
                width="1-1"
                class="uk-width-1-1"
                @pick="project_picked"
                @unpick="project_cleared"
            >
                <template v-slot:option="{ option }">
                    {{ option.name }}
                    <div><small>{{ option.firm }}</small></div>
                </template>
            </form-sourced-autosuggest>
            <div v-if="!!instructions && editable">
                <small class="uk-text-muted">{{ instructions }}</small>
            </div>
        </div>
        <div v-if="singleChoice && !!value" class="uk-flex">
            <router-link
                :to="{ name: 'project.edit', params: { id: project_by_value(value).id } }"
                class="uk-form-controls-text uk-flex-item-1"
                target="_blank"
            >
                <span v-if="!!project_by_value(value).number">{{ project_by_value(value).number }} </span>{{ project_by_value(value).nickname || project_by_value(value).name }}
            </router-link>
            <a
                v-if="editable"
                href
                class="uk-button uk-button-mini uk-button-link lam-show-on-hover"
                @click.prevent="project_picked(project_by_value(value))"
            >
                <open-icon glyph="remove" />
            </a>
        </div>
        <span v-else-if="singleChoice && (!value)" class="uk-text-muted">(None)</span>
        <ul
            v-else-if="!!value && !!value.length"
            :class="{ 'uk-margin-small-left': horizontal, 'uk-margin-top-remove': horizontal, 'uk-flex-item-1': horizontal, 'uk-margin-top': !horizontal }"
            class="uk-list uk-list-line"
        >
            <li
                v-for="option in value"
                :key="option"
            >
                <slot name="selected" :value="option">
                    <router-link
                        :to="{ name: 'project.edit', params: { id: option } }"
                        target="_blank"
                    >
                        <span v-if="!!project_by_value(option).number">{{ project_by_value(option).number }} </span>{{ project_by_value(option).nickname || project_by_value(option).name }}
                    </router-link>
                    <a
                        v-if="editable"
                        href
                        class="uk-button uk-button-mini uk-button-link lam-show-on-hover"
                        @click.prevent="project_picked(project_by_value(option))"
                    >
                        <open-icon glyph="remove" />
                    </a>
                    <div v-if="!!project_by_value(option).client_name"><small>{{ project_by_value(option).client_name }}</small></div>
                </slot>
            </li>
        </ul>
        <div v-else class="uk-text-muted uk-margin-small-top">(No projects selected)</div>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import FormSourcedAutosuggest from "./FormSourcedAutosuggest"
import OpenIcon from "./OpenIcon"

export default {
    components: {
        FormSourcedAutosuggest,
        OpenIcon
    },
    methods: {
        project_picked (project) {
            if(project && project[this.idField]) {
                if(this.singleChoice) {
                    this.$emit("pick", (this.value === project[this.idField]) ? null : project[this.idField], this.name)
                } else {
                    const value = this.value.slice()
                    const index = value.indexOf(project[this.idField])
                    if(index < 0) value.push(project[this.idField])
                    else if(index >= 0) {
                        value.splice(index, 1)
                        project[this.groupField] = null
                    }
                    this.$emit("pick", value, this.name)
                }
            }
        },
        project_cleared () {
            if(this.singleChoice) {
                const value = []
                this.$emit("pick", value, this.name)
            }
        },
        project_by_value (value) {
            return this.raw_project_records.find(project => project[this.idField] === value) || {}
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_project_records () {
            return this.entity_records("project")
        }
    },
    props: {
        id: {
            type: String,
            default: "project_id"
        },
        name: {
            type: String,
            default: ""
        },
        groupField: {
            type: String,
            default: "group_id"
        },
        value: {
            type: [Array, Number, String],
            required: false
        },
        idField: {
            type: String,
            default: "id"
        },
        labelField: {
            type: String,
            default: "name"
        },
        singleChoice: {
            type: Boolean,
            default: false
        },
        instructions: {
            type: String,
            default: ""
        },
        error: {
            type: String,
            default: ""
        },
        editable: {
            type: Boolean,
            default: true
        },
        horizontal: {
            type: Boolean,
            default: false
        }
    }
}
</script>
